import {
    SpacingToken,
    UiStack,
    UiText,
} from '@experiences/ui-common';
import { useNavigateWithParams } from '@experiences/util';
import { FontVariantToken } from '@uipath/apollo-core';
import {
    ApAlertBar,
    ApButton,
    ApLink,
} from '@uipath/portal-shell-react';
import React from 'react';
import { useIntl } from 'react-intl';

import { routePaths } from '../../common/constants/routePaths';
import { useDocumentationLinks } from '../../common/hooks/useDocumentationLink';

export const MODEL_VALIDATION_BANNER_DISMISSED = 'modelValidationBannerDismissed';

interface HomePageModelValidationComponentProps {
    onDismiss?: () => void;
}

export const HomePageModelValidationComponent: React.FC<HomePageModelValidationComponentProps> = ({ onDismiss }) => {
    const { formatMessage: translate } = useIntl();
    const navigate = useNavigateWithParams();
    const getLocalizedLink = useDocumentationLinks();
    const documentationLink = getLocalizedLink({ articleSlug: '/admin-guide/configuring-llms' });

    const handleNavigateToModelValidation = () => {
        navigate(routePaths.adminAiTrustLayerLlmConfigurations);
    };

    const handleDismiss = () => {
        sessionStorage.setItem(MODEL_VALIDATION_BANNER_DISMISSED, 'true');
        onDismiss?.();
    };

    return (
        <ApAlertBar
            cancelable
            onCancelAlert={handleDismiss}
            data-cy="home-page-model-validation-banner"
            style={{ width: '100%' }}
        >
            <UiStack
                direction="column"
                gap={SpacingToken.M}
                style={{ flex: 1 }}
            >
                <UiText variant={FontVariantToken.fontSizeMBold}>
                    {translate({ id: 'CLIENT_AUTOMATION_SUITE_AGENTIC_FEATURES_NOT_WORKING' })}
                </UiText>

                <UiText>
                    {translate({ id: 'CLIENT_AUTOMATION_SUITE_SETUP_LLM_IN_AITL' })}
                </UiText>

                <UiText>
                    {translate({ id: 'CLIENT_AUTOMATION_SUITE_AGENTIC_FEATURES_AFFECTED_SERVICES' })}
                </UiText>

                <UiStack
                    direction="row"
                    gap={SpacingToken.M}
                    align="center"
                    style={{ marginTop: '4px' }}
                >
                    <ApButton
                        variant="primary"
                        label={translate({ id: 'CLIENT_AUTOMATION_SUITE_CONFIGURE_LLM_SETTINGS' })}
                        onClick={handleNavigateToModelValidation}
                        data-cy="model-validation-navigate-button"
                    />

                    <ApLink
                        href={documentationLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-cy="model-validation-docs-link"
                    >
                        <UiText style={{ display: 'inline' }}>
                            {translate({ id: 'CLIENT_VIEW_DOCUMENTATION' })}
                        </UiText>
                    </ApLink>
                </UiStack>
            </UiStack>
        </ApAlertBar>
    );
};
